export default __webpack_public_path__ + "static/media/cards.f02aaa11.png";